<nz-drawer [nzWidth]="drawer_width" [nzVisible]="drawer_visible" nzTitle="Image flipper"
  (nzOnClose)="closeDrawer()">
  <ng-container *nzDrawerContent>
    @if (images.length == 0) {
      <div class="flipper-empty">
        <nz-empty nzNotFoundContent="No images have been added to the flipper yet"></nz-empty>
        <p class="empty-hint-mobile">
          Pin slice or shot images from the chat using the
          'Add to Image Flipper'
          button below an image, then flip through them here to compare iterations.
        </p>
        <p class="empty-hint">
          Pin slice or shot images from the chat using the
          <span nz-icon nzType="select" nzTheme="outline"></span>
          button in their top-right corner, then flip through them here to compare iterations.
        </p>
      </div>
    }

    @if (images.length > 0) {
      <!-- Toolbar -->
      <div class="flipper-toolbar">
        <div class="playback-controls">
          <button class="ctrl-btn" (click)="prev()" nz-tooltip nzTooltipTitle="Previous (←)">
            <span nz-icon nzType="left" nzTheme="outline"></span>
          </button>
          <button class="ctrl-btn ctrl-btn--play" (click)="togglePlayback()" [disabled]="images.length < 2"
            nz-tooltip [nzTooltipTitle]="is_playing ? 'Pause' : 'Auto-flip'">
            <span nz-icon [nzType]="is_playing ? 'pause' : 'caret-right'" nzTheme="outline"></span>
          </button>
          <button class="ctrl-btn" (click)="next()" nz-tooltip nzTooltipTitle="Next (→)">
            <span nz-icon nzType="right" nzTheme="outline"></span>
          </button>
          <span class="frame-indicator">{{ current_index + 1 }} / {{ images.length }}</span>
        </div>

        <div class="toolbar-right">
          <button class="ctrl-btn" [class.ctrl-btn--active]="fill_image" (click)="fill_image = !fill_image"
            nz-tooltip [nzTooltipTitle]="fill_image ? 'Fit image (preserve aspect ratio)' : 'Stretch to fill space'">
            <span nz-icon [nzType]="fill_image ? 'compress' : 'expand'" nzTheme="outline"></span>
          </button>
          <nz-select class="speed-select" [(ngModel)]="flip_interval_ms" (ngModelChange)="onSpeedChange()"
            nzSize="small">
            @for (opt of speed_options; track opt.value) {
              <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
            }
          </nz-select>
          <button class="ctrl-btn ctrl-btn--danger" nz-popconfirm
            nzPopconfirmTitle="Remove all images from the flipper?" nzOkText="Clear" [nzOkDanger]="true"
            (nzOnConfirm)="clear_all()" nz-tooltip nzTooltipTitle="Clear all">
            <span nz-icon nzType="delete" nzTheme="outline"></span>
          </button>
        </div>
      </div>

      <!-- Stage -->
      <div class="stage">
        @if (currentImage) {
          <div class="stage-meta">
            <div class="stage-job-name">{{ currentImage.image_information.job_name }}</div>
            <div class="stage-details">
              Iteration:
              {{ currentImage.image_information.iteration }}
              {{
              currentImage.image_information.dimension &&
              " | " + currentImage.image_information.dimension
              }}
              {{
              currentImage.image_information.slice_number &&
              "(" + currentImage.image_information.slice_number + ")"
              }}
            </div>
          </div>
        }
        <div class="stage-image-wrap" #imageWrap>
          <!-- all frames stay mounted so flipping is instant -->
          @for (image of images; track image; let i = $index) {
            <img [src]="image.image_link" class="stage-img" [class.visible]="i === current_index"
              [class.fill]="fill_image" />
          }
          @if (currentImage?.shot_overlay?.length) {
            <svg class="shot-overlay-svg" viewBox="0 0 1 1"
              [attr.preserveAspectRatio]="fill_image ? 'none' : 'xMidYMid meet'">
              @for (point of currentImage.shot_overlay; track $index) {
                <circle [attr.cx]="point.x" [attr.cy]="point.y" r="0.006" [attr.fill]="point.color"
                  (mouseenter)="on_shot_enter(point)" (mousemove)="on_shot_move($event, imageWrap)"
                  (mouseleave)="on_shot_leave()" />
              }
            </svg>
          }
          @if (hovered_shot(); as shot) {
            <div class="shot-tooltip" [style.left.px]="tooltip_pos().x + 12" [style.top.px]="tooltip_pos().y + 12">
              <div><b>Shot {{ shot.shot_id }}</b></div>
              <div>Fit: {{ shot.traces_fit | number: "1.0-2" }}</div>
              <div>x: {{ shot.sx | number: "1.0-1" }} · y: {{ shot.sy | number: "1.0-1" }} · z: {{ shot.sz | number: "1.0-1" }}</div>
            </div>
          }
        </div>
      </div>

      <!-- Thumbnails -->
      <div class="thumb-strip">
        @for (image of images; track image; let i = $index) {
          <div class="thumb" [class.active]="i === current_index">
            <img [src]="image.image_link" class="thumb-img" (click)="go_to_image(i)"
              nz-tooltip [nzTooltipTitle]="image.image_information.job_name + ' — iter ' + image.image_information.iteration" />
            <button nz-button nzSize="small" nzShape="circle" nzType="text" nzDanger class="image-remove-button"
              (click)="remove_image(i)">
              <span nz-icon nzType="close" nzTheme="outline"></span>
            </button>
          </div>
        }
      </div>
    }
  </ng-container>
</nz-drawer>
